import React from 'react'

import { SvgProps } from '../types'
import { Icon } from '../Icon'

export const Pause: React.FC<SvgProps> = (props) => {
  return (
    <Icon height="24" width="24" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M15.75 5.25V18.75M8.25 5.25V18.75"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </Icon>
  )
}
